import { AutogenModelHierarchyLevel, AutogenRowHierarchyLevel } from "./autogen/AutogenModelHierarchyLevel";

export class ModelHierarchyLevel extends AutogenModelHierarchyLevel<RowHierarchyLevel> {
	constructor() {
		super(RowHierarchyLevel);
	}
}

export class RowHierarchyLevel extends AutogenRowHierarchyLevel {
}